export const INDEXED_FIELDS = {
  orders: [
    { key: 'order_number', label: 'Order Number', type: 'string' },
    { key: 'reference_id', label: 'Reference ID', type: 'string' },
    { key: 'status', label: 'Status', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  'inbound-shipments': [
    { key: 'status', label: 'Status', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  'sales-orders': [
    { key: 'order_number', label: 'Order Number', type: 'string' },
    { key: 'reference_id', label: 'Reference ID', type: 'string' },
    { key: 'status', label: 'Status', type: 'string' },
    { key: 'order_date', label: 'Order Date', type: 'date' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  'sales-order-shipments': [
    { key: 'sales_order_id', label: 'Sales Order ID', type: 'string' },
    { key: 'shipment_number', label: 'Shipment Number', type: 'string' },
    { key: 'shipped_date', label: 'Shipped Date', type: 'date' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  'purchase-orders': [
    { key: 'order_number', label: 'Order Number', type: 'string' },
    { key: 'reference_id', label: 'Reference ID', type: 'string' },
    { key: 'status', label: 'Status', type: 'string' },
    { key: 'order_date', label: 'Order Date', type: 'date' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  'purchase-order-receipts': [
    { key: 'purchase_order_id', label: 'Purchase Order ID', type: 'string' },
    { key: 'receipt_number', label: 'Receipt Number', type: 'string' },
    { key: 'received_date', label: 'Received Date', type: 'date' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  items: [
    { key: 'sku', label: 'SKU', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  inventory: [
    { key: 'sku', label: 'SKU', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  products: [
    { key: 'sku', label: 'SKU', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  locations: [
    { key: 'name', label: 'Name', type: 'string' },
    { key: 'code', label: 'Code', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  customers: [
    { key: 'customer_number', label: 'Customer Number', type: 'string' },
    { key: 'name', label: 'Name', type: 'string' },
    { key: 'email', label: 'Email', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  vendors: [
    { key: 'vendor_number', label: 'Vendor Number', type: 'string' },
    { key: 'name', label: 'Name', type: 'string' },
    { key: 'email', label: 'Email', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  employees: [
    { key: 'employee_number', label: 'Employee Number', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  billing: [
    { key: 'warehouse_customer_id', label: 'Warehouse Customer ID', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
    { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
    { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
  ],
  files: [
    { key: 'file_name', label: 'File Name', type: 'string' },
    { key: 'file_type', label: 'File Type', type: 'string' },
    { key: 'created_date', label: 'Created Date', type: 'date' },
    { key: 'updated_date', label: 'Updated Date', type: 'date' },
  ],
};

const DEFAULT_FIELDS = [
  { key: 'created_date', label: 'Created Date', type: 'date' },
  { key: 'updated_date', label: 'Updated Date', type: 'date' },
  { key: 'trackstar_created_date', label: 'Trackstar Created Date', type: 'date' },
  { key: 'trackstar_updated_date', label: 'Trackstar Updated Date', type: 'date' },
];

export const getIndexedFields = (resourceKey) => (
  INDEXED_FIELDS[resourceKey] || DEFAULT_FIELDS
);

export const DATE_OPERATORS = [
  { key: 'gte', label: '>=' },
  { key: 'lte', label: '<=' },
];

const resolveRef = (ref, spec) => {
  const name = ref?.split('/')?.pop();
  return name ? spec?.components?.schemas?.[name] : null;
};

export const getStatusEnums = (spec, apiPath) => {
  if (!spec || !apiPath) return null;
  const listSchema = resolveRef(
    spec.paths?.[`/${apiPath}`]?.get?.responses?.['200']?.content?.['application/json']?.schema?.$ref,
    spec,
  );
  const itemSchema = resolveRef(listSchema?.properties?.data?.items?.$ref, spec);
  return itemSchema?.properties?.status?.enum || null;
};
